import { React, useState, useEffect } from 'react';
import SideBar from '../Doctor UI/Doctor-Sidebar';
import "../../styles/Doctor-ui/Doctorhomepage.css";
import "../../styles/Doctor-ui/doctor-appointment-div.css";
import { FaCheckCircle, FaCheck } from "react-icons/fa";
import DoctorSideBar from '../Doctor UI/Doctor-Sidebar';
import PreviousAppointments from './PreviousAppointments';
import IncompleteEncounters from './IncompleteEncounters';
import AppointmentsViewer from './AppointmentsViewer';
import Youroheader from '../Youro-header';
import { API_DETAILS, USER_TYPES } from '../../App';

import Cookies from "js-cookie";
import { COOKIE_KEYS } from '../../App';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../utils/loader';
import { ToastContainer, toast } from 'react-toastify';

import Popup from 'reactjs-popup';
import Button from '@mui/material/Button';
import PatientSymptomChart from '../Patient UI/Patient-symptom-chart';


function DoctorHomePage() {
  const [isVisible, setIsVisible] = useState(false);
  const [openSymChart, setOpenSymChart] = useState(false);
  const [clickedPatId, setClickedpatId] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [apptId, setApptId] = useState(null);
  const [patId, setPatId] = useState(null);
  const [diagId, setDiagId] = useState(null);
  

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const navigate = useNavigate();

  useEffect(() => {
    // if(Cookies.get(COOKIE_KEYS.userType) != 'PROVIDER')
    //   {
    //      navigate("/");  
    //   }
    const fetchData = async () => {
        const authStatus = await checkAuthorizationStatus();
        fetchPrevAndUpcomingAppointments();
    // setOpenCreatePopUp(false);
    };
    fetchData();
  }, []);


  const uId = Cookies.get(COOKIE_KEYS.userId);//1; 
  const [prevAppts, setPrevAppts] = useState([]);
  const [upComingAppts, setUpcomingAppts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenCreatePopUp, setOpenCreatePopUp] = useState(false);
  const [meetLink, setMeetLink] = useState(null);
  const [meetingId, setMeetingId] = useState(null);
  const [activeLoader, setActiveLoader] = useState(false);

  const appointments_image = (arrayBuffer) => {
   
     const arrayBuffer1 = new Uint8Array(arrayBuffer);
     if(arrayBuffer1.length!=0)
       {
        const base64String = btoa(new Uint8Array(arrayBuffer1).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '')
        );
      return `data:image/png;base64,${base64String}`;
       }
      return null;
  };

  const isValidMeetingLink = (link) => {
    // Regular expression to validate URL format
    const urlRegex = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    //const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/;
    return urlRegex.test(link);
    //return link.match(urlRegex);
  };
  
  const createMeetLink = () => {

      axios.put(API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension + "/updateAppointment/" + `${meetingId}` + `?link=${meetLink}`, {}).then((res) => {
        toast.success("Uploaded meet link successfully");fetchPrevAndUpcomingAppointments(); setOpenCreatePopUp(false) }).catch(e => toast.error('Error uploading meet link'))
    
  };

  const fetchPrevAndUpcomingAppointments = async () => {
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/appointments/${uId}?timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
    //const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/appointments/${uId}?timeZone=UTC`;
    console.log("checking the url",url);
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json',
        //  'responseType': 'arraybuffer' 
        'responseType': 'arraybuffer' 
      }
    };
    setIsLoading(true);
    try {
      const res = await axios.get(url, config);
      console.log("checking the data in appointments",res.data);
      setPrevAppts(res.data.previousAppointments);
      setUpcomingAppts(res.data.upComingAppointments);
      //console.log("checking uid",res.data);
      setIsLoading(false);
    }
    catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  }

  const handleJoinMeeting = async (item) => {
      const meetingWindow = window.open(item.link, '_blank');

      if (!meetingWindow) {
         alert("The meeting link could not be opened. Please make sure pop-ups are allowed.");
         return;
      }

      // Wait for a brief moment before checking
      setTimeout(() => {
        const checkWindowClosed = setInterval(() => {
          if (meetingWindow.closed) {
            clearInterval(checkWindowClosed);
            setApptId(item.apptId);
            setPatId(item.patientId);
            setDiagId(item.diagId);
            openMeetingDonePopup();
          }
        }, 1000);
      }, 500);
  };

  const openMeetingDonePopup = () => setIsOpen(true);
  const closeMeetingDonePopup = () => setIsOpen(false);

  const handleMeetingFinished = async () => {
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/finishMeeting/${apptId}`;
      const config = {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Content-Type': 'application/json'
        }
    };
    setIsLoading(true);

    try {
      const res = await axios.put(url, config);
      closeMeetingDonePopup();
    }
    catch (err) {
      toast.error("Error finishing the appointment");
      console.error(err);
    }
    setIsLoading(false);
    navigate(`/doctor-view-profile/${patId}/${apptId}`, { state: {diagId} });
  };

   const cancelAppointment = async (data) => {

      const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/cancelAppointment/${data.apptId}/${data.doctorId}`;
      const config = {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Content-Type': 'application/json'
        }
    };
    setIsLoading(true);

      try {
        const res = await axios.put(url, config);
        fetchPrevAndUpcomingAppointments()
        toast.success("Appointment cancelled successfully");
      }
      catch (err) {
        toast.error("Error cancelling appointment");
        console.error(err);
      }
      setIsLoading(false);
    }

  const ImagePrev = (data) => {
    const arrayBuffer = new Uint8Array(data);
        if(arrayBuffer.length!=0)
        {
        const base64Image = btoa(
          new Uint8Array(arrayBuffer).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
      //    const base64Image = btoa(
      //   String.fromCharCode.apply(null, arrayBuffer)
      // );
        //  const contentType = response.headers['content-type'];
        return `data:image/png;base64,${base64Image}`;
        // return `data:image/png;base64,${base64Image}`;
  }
  }

  const checkAuthorizationStatus = async () => {
        const uId = Cookies.get(COOKIE_KEYS.userId);
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/checkGMeetAuthStatus/${uId}`;
        console.log("Backend URL for checkAuthorizationStatus is : ", url);
        const config = {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Content-Type': 'application/json'
          }
        };

        try {
            const res = await axios.get(url, config);
            const statusMessage = res.data;

            if (statusMessage === "Authentication success") {
                setIsAuthorized(true);
                return true;
            } else {
              return false;
            }
        } catch (error) {
            console.error('Error checking authorization status:', error);
            return false;
        }
    };

  const TodayAppointmentList = () => {

    // Get today's date
    const today = new Date();
    // Convert to MM/DD/YYYY format
    const formattedToday = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;

    // Filter upcoming appointments to get only today's appointments
    const todayAppointments = upComingAppts.filter(item => {
      const appointmentDate = new Date(item.apptStartTime);
      // Convert appointment date to MM/DD/YYYY format
      const formattedAppointmentDate = `${appointmentDate.getMonth() + 1}/${appointmentDate.getDate()}/${appointmentDate.getFullYear()}`;
      // Check if the appointment date matches today's date
      return formattedAppointmentDate === formattedToday;
    });

    const fetchAuthorizationUrl = async () => {
        const uId = Cookies.get(COOKIE_KEYS.userId);
        if (!isAuthorized) {
            const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAuthorizationUrl/${uId}`;
            console.log("Backend URL for auth is : ", url);
            const config = {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
              }
            };

            try {
              const res = await axios.get(url, config);
              console.log("fetchAuthorizationUrl res: ", res);
              const authUrl = res.data;
              console.log("fetchAuthorizationUrl authUrl: ", authUrl);
              const authWindow = window.open(authUrl, '_blank');

              if (!authWindow) {
                alert("The meeting link could not be opened. Please make sure pop-ups are allowed.");
                return;
              }

              let elapsedTime = 0;
              const intervalTime = 500;
              const timeoutDuration = 1000 * 60 * 2; // 2 mins

              // Check status by polling for every 1/2 sec
              setTimeout(() => {
                const intervalId = setInterval(async () => {

                  if (authWindow.closed) {
                    const status = await checkAuthorizationStatus();
                    if (status) {
                      clearInterval(intervalId);
                      toast.success("Authorization for Calendar access successful!");
                      fetchPrevAndUpcomingAppointments();
                    } else {
                      clearInterval(intervalId);
                      toast.error("Authorization Failed!");
                    }
                  } else {
                    elapsedTime += intervalTime;
                    if (elapsedTime >= timeoutDuration) {
                      clearInterval(intervalId);
                      toast.error("Authorization timed out.");
                    }
                  }
                }, intervalTime);
              }, 500);
            } catch (err) {
              console.error('Error fetching authorization URL:', err);
              return null;
            };
        }
    };

    const openLinkPopUp = (item) => {
      if (!isAuthorized) {
        // toast.error('Please Allow Calendar Access in Profile!');
        // Redirecting to Authorization page
        fetchAuthorizationUrl();
      } else {
          setMeetingId(item.apptId);
          item.link && setMeetLink(item.link);
          setOpenCreatePopUp(true);
      }
    }

    const openZoomLink = (link) => {
      // window.open(link, '_blank');
    }

    const openPatSymScore = (patId) => {
      setClickedpatId(patId);
      //setOpenSymChart(true);
    }

    return (
      <div>
        {
          (todayAppointments.length == 0 ) && <>
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3 style={{ marginTop: '50%' }}><i>No record of appointments</i></h3>
            </div>
          </>
        }

        {/*<div className='previous-appointment' onClick={toggleVisibility}>*/}

        {todayAppointments && todayAppointments.length != 0 && todayAppointments.map((item) => (
          <div className='previous-appointment'>
            <div> 
            {/* Was item.apptStartTime.split(' ')[4].split(':'), which assumed the
                timestamp always had the shape "Sat Aug 29 2026 15:00:00 GMT+0000
                (UTC)" and that index 4 was the time. Any other shape — or the empty
                string convertDateTime returns when it cannot format a date — made
                [4] undefined and threw. It also read the time straight out of the
                server's UTC string while the date beside it was converted to local,
                so the two disagreed. Both now come from the same local Date. */}
            <h3 style={{display: 'inline-block'}}>{new Date(item.apptStartTime).toLocaleDateString()}, {new Date(item.apptStartTime).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</h3>{item.status == 'CANCELED' && <div className='cancel-tag'>cancelled</div>}
              
                <div style={{ display: 'flex',flexDirection:'row',height:'30px',marginTop:'1.5%'}}>
                  <img
                 // src={item.picture? `data:image/png;base64,${item.picture}`: 'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=740&t=st=1697800963~exp=1697801563~hmac=a964f83412aeedf85e035a4192fe19e1c7001f7ec339ba51104c9372481f77c9'}
                // src={item.picture!=null ? ImagePrev(item.picture): 'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=740&t=st=1697800963~exp=1697801563~hmac=a964f83412aeedf85e035a4192fe19e1c7001f7ec339ba51104c9372481f77c9'}
                      src={require("../../assets/Display_icon.png")} className="profile-pic" alt="Patient Image" width="25" height="25"/>
              <h3 style={{marginTop:'2%',marginLeft:'2%'}}>
                <Link style={{ textDecoration: 'none' }} to={`/doctor-view-profile/${item.patientId}`}>{item.patientName}</Link>
              </h3>
            </div>
                {/* {item.patientName}</h3> */}
            </div>
            <ul key={item.apptId}>
              <li>Diagnosisname: {item.diagName}</li>
              {/* <li onClick={openPatSymScore}>Symptom score: {item.symptomScore}</li> */}
              {/* The score now opens this patient's Results tab, where their most
                  recent assessment is, so the provider can read the answers and
                  start the note. openPatSymScore only set state that nothing
                  rendered, so the link previously did nothing at all. */}
              {item.status != 'CANCELED' && <li style={{ textDecoration: 'underline', color: 'var(--youro-sage)', cursor: 'pointer' }}><Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/doctor-view-profile/${item.patientId}?tab=results`}>Symptom score: {item.symptomScore}</Link></li>}
              <li style={{ textDecoration: 'underline', color: 'var(--youro-sage)', cursor: 'pointer' }}><Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/doctor-view-profile/${item.patientId}`}>View Profile</Link></li>
            </ul>
            {
              item.link && (item.status == 'SCHEDULED' ) && <>
                <div>
                {/* <button className='join-now-button' >Join Now</button> */}
                <button className='join-now-button' style={{ width: 'fit-content', margin: '0px 10px 10px 10px',padding: '2px 10px', cursor: 'pointer' }}
                  onClick={() => handleJoinMeeting(item)}>Join Now</button>
                <button className='join-now-button' style={{ width: 'fit-content', margin: '0px 10px 10px 10px', padding: '2px 10px', cursor: 'pointer' }}onClick={() => openLinkPopUp(item)}>Edit Link</button>
                <button className='join-now-button' style={{width:'fit-content',margin: '0px 10px 10px 10px', padding: '2px 10px',cursor:'pointer'}} onClick={() => cancelAppointment(item)}>Cancel</button>
                </div>
              </>
            }
            {
              !item.link && item.status == 'SCHEDULED' && <>
                <div>
                <button className='join-now-button' style={{ width: 'fit-content', margin: '0px 20px 10px 20px', padding: '0px 5px', cursor: 'pointer' }}
                  onClick={() =>openLinkPopUp(item)} >Authorize Calendar</button>
                <button className='join-now-button' style={{width: 'fit-content', margin: '0px 20px 10px 20px', padding: '0px 5px', cursor: 'pointer'}} onClick={() => cancelAppointment(item)} >Cancel</button>
                </div>
              </>
            }
             {/* <button>cancel</button> */}
            

          </div>
        ))

        }
        
      </div>
    );
  };




  return (
     <div className='hm-doctor'>
        <Loader active={isLoading} />
        <div className='sidebar'>
         <DoctorSideBar data={'doctor-home'}/>
       </div>
       <div className='care-plan-doctor'>
         <Youroheader />
         {/* <h1>youro</h1> */}
        <div className='all-details-doctor'>
          <div className='care-plan-details-doctor'>
            <h2 style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} >Today's Appointments</h2>
            <div className='care-plan-details-doctor-scroll-section'>
              <TodayAppointmentList/>
            </div>
          </div>
          {isVisible &&
            <div className='care-plan-details-doctor'>
              <h2>Previous Appointments</h2>
              <div className='care-plan-details-doctor-scroll-section'>
                <PreviousAppointments data={prevAppts} />
              </div>
            </div>}
          {/*
          <div className='care-plan-details-doctor'>
            <h2 style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} >Incomplete Encounters</h2>
            <div className='care-plan-details-doctor-scroll-section'>
              <IncompleteEncounters />
            </div>
          </div>
          */}
          <div className='appointments-viewer-doctor'>
            <h2 style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Appointments Viewer</h2>
            <div className='appointments-viewer-doctor-scroll-section'>
              <AppointmentsViewer />
            </div>
          </div>
        </div>
      </div>
      {isOpenCreatePopUp && 
        <>
          <Popup open={isOpenCreatePopUp} modal closeOnDocumentClick={false} onClose={() => {setOpenCreatePopUp(false); }} className="congrats-popup">
            <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }} onClick={() => { setOpenCreatePopUp(false); }}>
              <span class="material-symbols-outlined">
                close
              </span>
            </div>

            <div style={{ padding: '50px 20px' }}>
              <div style={{ width: '300px' }}>

              </div>
              <div className="">
                <label>Meeting link:</label>
                <input className="input-field-doctor input-border" type="text" style={{ width: '94%' }} value={meetLink} onChange={e => {setMeetLink(e.target.value)}} />
              </div>
              {meetLink && !isValidMeetingLink(meetLink) && (
                <div style={{ color: 'red', fontSize: '90%', paddingTop: '1%'}}>Please enter a valid Meeting link<br/>example: https://example.com</div>
              )}

            </div>

            <div>
              <div className='btn-filled' style={{ width: 'fit-content', margin: '0px auto 50px auto' }} onClick={() => {
                if (isValidMeetingLink(meetLink)) {
                  createMeetLink();
                } else {
                  //alert("Please enter a valid Meeting link format.");
                  toast.error("could not upload link, please enter a valid link format.");
                }
                }}>Upload
              </div>
            </div>


          </Popup>
        </>
      }
      {openSymChart && 
        <>
          <Popup open={openSymChart} modal closeOnDocumentClick={false} onClose={() => setOpenSymChart(false)} className="chart-popup">
            <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }} onClick={() => { setOpenSymChart(false) }}>
              <span class="material-symbols-outlined">
                close
              </span>
            </div>

            <div style={{ padding: '50px 20px', minWidth: '30vw' }}>
              <div style={{ minWidth: '30vw' }}>
              </div>
              <div className="">
                <PatientSymptomChart uId={clickedPatId}   doctorView={true} />
              </div>

            </div>


          </Popup>
        </>
      }
       { isOpen &&
         <>
           <Popup
             open={isOpen}
             closeOnDocumentClick={false}
             onClose={closeMeetingDonePopup}
             modal
             contentStyle={{
                width: '25%',
                height: '20%',
                borderRadius: '16px',
                overflow: 'hidden',
                padding: 0
              }}
           >
             <div className="popup-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%', maxHeight: '100% !important', overflowY: 'hidden !important'}}>
                 <div className="info-col" >
                   <h3 style={{ textAlign: 'center', margin: 0 }}>Has the meeting finished?</h3>
                 </div>
                 <div className="buttons-col" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                   <div className="col-6">
                     <Button
                       onClick={closeMeetingDonePopup}
                       variant="outlined"
                       style={{ backgroundColor: 'red', color: 'white', marginRight: "25px" }}
                     >
                       No
                     </Button>
                   </div>
                   <div className="col-6">
                     <Button
                       onClick={handleMeetingFinished}
                       variant="contained"
                       style={{ backgroundColor: 'green', color: 'white', marginLeft: "25px" }}
                     >
                       Yes
                     </Button>
                   </div>
                 </div>
             </div>
           </Popup>
         </>
       }
       <ToastContainer />
    </div>
  )
}

export default DoctorHomePage;